import script from "./navigationSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationSidebar.vue?vue&type=script&setup=true&lang=js"

import "./navigationSidebar.vue?vue&type=style&index=0&id=1009b62c&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1009b62c"]])

export default __exports__